import 'magnific-popup'

$(document).ready(function() {
    $('.lightbox').magnificPopup({
        type:'image',
        gallery: { enabled:true }
    });
});